class PlanBox {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.planBox')

    if (!this.section)
      return

    this.buttons = this.section.querySelectorAll('.planBox__wrapperButton')
    this.popups  = this.section.querySelectorAll('.planBox__popup')
    this.numbers = this.section.querySelectorAll('.planBox__popupGroupItem')
    this.lines   = this.section.querySelectorAll('.planBox__route')

    return true

  }

  setEvents() {

    this.buttons.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.showPopup(index)

      })

    })

    this.numbers.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.showLine(index)

      })

    })

    $('.planBox__wrapperSubmit').unbind('click');
    $('.planBox__wrapperSubmit').bind('click', function() {
    	location.href = '//epoznan.pl/index.php?section=komunikacja&subsection=mpk&mode=line&line=' + $('.planBox__wrapperInput').val();
    });

  }

  showPopup(index) {

    const isActive = this.buttons[index].hasClass('planBox__wrapperButton--active')

    this.buttons.removeClass('planBox__wrapperButton--active')
    this.popups.removeClass('planBox__popup--active')

    if (isActive)
      return

    this.buttons[index].addClass('planBox__wrapperButton--active')
    this.popups[index].addClass('planBox__popup--active')

  }

  showLine(index) {

    const line = this.numbers[index].getAttribute('data-line')
    const list = this.section.querySelectorAll('.planBox__route[data-line="' + line + '"]')

    this.numbers.removeClass('planBox__popupGroupItem--active')
    this.numbers[index].addClass('planBox__popupGroupItem--active')

    this.lines.removeClass('planBox__route--active')
    list.addClass('planBox__route--active')


  }

}
